import {
  globalMessageHandler,
  Rules,
  ValidationErrors,
  Validator,
} from "common";
import { useAppDispatch, useAppSelector } from "app/hooks";
import I18n from "i18n-js";
import { useEffect, useRef, useState } from "react";
import { LoginForm } from "./identityAPI";
import { loginAsync, selectIdentityStatus } from "./identitySlice";

export const detectAutofill = (element: any): Promise<boolean> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(
        window
          .getComputedStyle(element, null)
          .getPropertyValue("appearance") === "menulist-button"
      );
    }, 600);
  });
};

export interface LoginFromProps {
  defaultValues?: LoginForm;
}

export function validateLoginForm(values: LoginForm) {
  const rules: Rules = {
    email: Validator.rule.string().required(),
    password: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "LoginForm");
}

export default function useLoginFrom({ defaultValues }: LoginFromProps) {
  const [item, setItem] = useState<LoginForm>(
    defaultValues || ({} as LoginForm)
  );
  const emailFieldRef = useRef<HTMLInputElement>(null);
  const passwordFieldRef = useRef<HTMLInputElement>(null);
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [autofilled, setAutofilled] = useState<boolean>();
  const status = useAppSelector(selectIdentityStatus);

  const dispatch = useAppDispatch();
  function onChange(values: LoginForm) {
    if (autofilled) {
      setAutofilled(undefined);
    }
    setItem(values);
  }

  /**
   * Check if dom input values are not equal with state. Predicting its an autofill
   * @returns boolean
   */
  function isAutoFilled(): boolean {
    console.log({ v: emailFieldRef.current?.value });
    return !!emailFieldRef.current?.matches(":-webkit-autofill");
    /*return !!(
      (
        (emailFieldRef.current &&
          emailFieldRef.current.value !== item.email &&
          item.email !== undefined) ||
        (passwordFieldRef.current &&
          passwordFieldRef.current.value !== item.password &&
          item.password !== undefined)
      )
      //emailFieldRef.current.matches(":-internal-autofill-selected")
    );*/
  }

  async function login() {
    let _item = { ...item };

    if (isAutoFilled()) {
      _item.email = emailFieldRef.current?.value || "";
      _item.password = passwordFieldRef.current?.value || "";
      setItem(_item);
    }

    const result = validateLoginForm(_item);
    setErrors(result.errors);

    if (!result.success) {
      return;
    }

    const response = await dispatch(loginAsync(_item));

    if (response.meta.requestStatus === "fulfilled") {
      globalMessageHandler.success(I18n.t("LoginForm.successfullLogin"));
    } else {
      if (response.payload) {
        setErrors({
          password: response.payload.message,
        });
      }
    }
  }

  async function changeAutofill() {
    setAutofilled((await detectAutofill(emailFieldRef.current)) || undefined);
  }

  useEffect(() => {
    changeAutofill();
  }, []);

  return {
    item,
    errors,
    loading: status === "loading",
    onChange,
    login,
    emailFieldRef,
    passwordFieldRef,
    autofilled,
  };
}
